<template lang="html">
  <div class="modal-wrapper" style="overflow: visible;">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      {{modalData.title}}
    </div>
    <div class="inputs">
      <div v-for="(input, index) in modalData.inputs" :key="index" class="single-input">
        <span>{{input.label}}</span>
        <dropdown
          v-if="input.type && input.type === 'dropdown'"
          :defaultText="input.label"
          :selected="input.value"
          :list="input.dropdownList"
          @changeOption="input.value = $event"
        />
        <input v-else-if="input.type && input.type === 'time'" type="time" v-model="input.value">
        <input v-else v-model="input.value" type="text">
      </div>
    </div>
    <div class="btn-wrapper">
      <div @click="post" class="btn">
        ok
      </div>
      <div @click="closeModal" class="btn">
        cancel
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/dropdown.vue'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'addCodebook',
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  components: {
    Dropdown
  },
  mounted () {
    this.populateDropdowns()
  },
  methods: {
    closeModal () {
      eventBus.$emit('closeModal')
    },
    post () {
      console.log(this.modalData.inputs)
      let params = {}
      for (var i = 0; i < this.modalData.inputs.length; i++) {
        let input = this.modalData.inputs[i]
        if (input.type === 'dropdown') {
          if (input.value) {
            params[input.key] = input.value.value
          }
        } else {
          if (input.value) {
            params[input.key] = input.value
          }
        }
      }
      api[this.modalData.postApi](params).then(res => {
        console.log(res)
        this.modalData.refresh()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      }).finally(() => {
        this.clearInputs()
        this.closeModal()
      })
    },
    clearInputs () {
      let inputs = this.modalData.inputs
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].value = null
      }
    },
    populateDropdowns () {
      for (var i = 0; i < this.modalData.inputs.length; i++) {
        if (this.modalData.inputs[i].type && this.modalData.inputs[i].type === 'dropdown') {
          let input = this.modalData.inputs[i]
          api[input.dropdownApi]().then(res => {
            input.dropdownList = this.fixDropdownData(res.data.data, input.dropdownApi)
            console.log(input)
          }).catch(e => {
            console.log(e)
          })
        }
      }
    },
    fixDropdownData (data, apiUrl) {
      let res = []
      if (apiUrl === 'getCurrencies') {
        for (var i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].cur_name,
            value: data[i].cur_id
          }
          res.push(obj)
        }
      }
      if (apiUrl === 'getParentCategories') {
        for (i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].cat_name,
            value: data[i].cat_id
          }
          res.push(obj)
        }
      }
      return res
    }
  },
  computed: {
    getDropdownList () {
      return (apiUrl) => {
        let data = []
        api[apiUrl]().then(res => {
          data = res.data.data
        }).catch(e => {
          data = []
        })
        return data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
